import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import CustodiyAIAgentSidebar from './CustodiyAIAgentSidebar';

const AIButtonContainer = styled.button`
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 2px solid rgba(6, 182, 212, 0.8);
  background: rgba(7, 11, 20, 0.9);
  backdrop-filter: blur(12px);
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3), 0 0 0 0 rgba(6, 182, 212, 0.4);
  
  &:hover {
    border-color: rgba(6, 182, 212, 1);
    background: rgba(7, 11, 20, 0.95);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.4), 0 0 0 4px rgba(6, 182, 212, 0.2);
    transform: translateY(-2px);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3), 0 0 0 2px rgba(6, 182, 212, 0.3);
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.4), 0 0 0 4px rgba(6, 182, 212, 0.3);
  }

  @media (max-width: 768px) {
    width: 48px;
    height: 48px;
    font-size: 14px;
    bottom: 20px;
    right: 20px;
  }
`;

const NotificationDot = styled.span`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(6, 182, 212, 1);
  border: 2px solid rgba(7, 11, 20, 0.9);
`;

const AIButton = ({ onClick }) => {
  const { isLoggedIn } = useSelector(state => state.user);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [hasNotification, setHasNotification] = useState(false);

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      setIsSidebarOpen(true);
      setHasNotification(false);
    }
  };

  const sidebarContent = (
    <CustodiyAIAgentSidebar 
      open={isSidebarOpen} 
      onClose={() => setIsSidebarOpen(false)} 
    />
  );

  // Only render if user is logged in
  if (!isLoggedIn) {
    return null;
  }

  return (
    <>
      <AIButtonContainer onClick={handleClick} aria-label="AI Assistant">
        AI
        {hasNotification && <NotificationDot />}
      </AIButtonContainer>
      {ReactDOM.createPortal(sidebarContent, document.body)}
    </>
  );
};

export default AIButton;
